import { Action, Reducer } from 'redux';
import {
  ExcludeVariablesState,
  ExcludeVariablesTypes,
  ExcludeVariablesActionTypes
} from './excludeVariablesTypes';
import { haskeyReducer, updateGetIsolated, updateSaveIsolated } from '@/main/services/reducerUtils';

export const INITIAL_STATE: ExcludeVariablesState = {
  excludeVariables: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  },
  isolated: {}
};

const excludeVariablesReducer: Reducer<ExcludeVariablesState> = (
  state: ExcludeVariablesState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as ExcludeVariablesActionTypes;
  switch (actionTypes.type) {
    case ExcludeVariablesTypes.GET_EXCLUDE_VARIABLES:
      const isKeyReducer = haskeyReducer(actionTypes.payload.keyReducer);

      if (isKeyReducer) return updateGetIsolated(state, actionTypes);

      return {
        ...state,
        excludeVariables: { ...state.excludeVariables, isLoading: true }
      };
    case ExcludeVariablesTypes.SAVE_EXCLUDE_VARIABLES:
      const isKeyReducerSave = haskeyReducer(actionTypes.payload.keyReducer);

      if (isKeyReducerSave) return updateSaveIsolated(state, actionTypes);

      return {
        ...state,
        excludeVariables: {
          ...state.excludeVariables,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case ExcludeVariablesTypes.RESET_REDUCER_EXCLUDE_VARIABLES:
      return {
        ...state,
        excludeVariables: INITIAL_STATE.excludeVariables
      };
    default:
      return state;
  }
};

export default excludeVariablesReducer;
